import { useMemo, useState, useSyncExternalStore } from 'react';
import usePostShareHook from './usePostShareHook';
import SharePopup, { SharePopupTab } from '../SharePopup';
import PostShareDownloadTab from './PostShareDownloadTab';
import PostShareLinkTab from './PostShareLinkTab';
import { useAppContext } from '@/context/AppContext/AppContext';
import { TextAsset } from '@/Pages/PostsListPage/types';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';

export default function PostSharePopup({
  selectedPost,
  onPostShared
}: {
  selectedPost: TextAsset | null;
  onPostShared: () => void;
}) {
  const { adminAppStore } = useAppContext();
  const { setPostAsShared } = usePostShareHook(selectedPost);

  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const isDownloadRevampEnabled = featureFlags[FeatureFlagKeys.Use_CL_Download_Revamp];

  const allTabs: SharePopupTab[] = useMemo(
    () => [
      {
        key: 'post-share-link-tab',
        title: 'Link',
        tabComponent: <PostShareLinkTab post={selectedPost} />
      },
      {
        key: 'post-share-download-tab',
        title: 'Download',
        tabComponent: <PostShareDownloadTab post={selectedPost} />
      }
    ],
    [selectedPost]
  );

  const tabs = useMemo(() => {
    if (isDownloadRevampEnabled) {
      return [allTabs[0]];
    }
    return allTabs;
  }, [isDownloadRevampEnabled, allTabs]);

  const [currentTab, setCurrentTab] = useState(tabs[0]);

  const beforeOpen = () => {
    adminAppStore.dispatch?.('user/showForceChangePasswordDialogIfRequired');
    setCurrentTab(tabs[0]);
    setPostAsShared()?.then(() => onPostShared());
  };

  return (
    <SharePopup
      currentTab={currentTab}
      tabs={tabs}
      beforeOpen={beforeOpen}
      setCurrentTab={setCurrentTab}
      icon={isDownloadRevampEnabled ? 'IconShare3' : 'IconShare2'}
    />
  );
}
